import { put } from 'redux-saga/effects'
import { IPcr } from '../../pcr/store/pcr.types'
import {
  setCardiacArrestState,
  setCcHpiInjuryDetails,
  setHistoryState,
  setSituationState,
} from '../store/ccHpi.actions'

export function* getCcHpi(pcrDoc: IPcr) {
  const { situation, history, ccHpiCardiacArrest, ccHpiInjuryDetails } = pcrDoc
  if (situation && Object.keys(situation).length !== 0) {
    yield put(setSituationState(situation))
  }
  if (history && Object.keys(history).length !== 0) {
    yield put(setHistoryState(history))
  }
  if (ccHpiCardiacArrest && Object.keys(ccHpiCardiacArrest).length !== 0) {
    yield put(setCardiacArrestState(ccHpiCardiacArrest))
  }
  if (ccHpiInjuryDetails && Object.keys(ccHpiInjuryDetails).length !== 0) {
    yield put(setCcHpiInjuryDetails(ccHpiInjuryDetails))
  }
}
